












































import { Component, Vue, Prop } from 'vue-property-decorator';
import EchartOption from '@/common/const/e-chart-options';

@Component({
  components: {}
})
export default class BarLine extends Vue {
  options: EchartOption = new EchartOption();
  isData: boolean = true;
  //柱形图数据
  @Prop({
    default: {
      handLift: [],
      special: [],
      repair: [],
      free: []
    }
  })
  barData: any;
  //折线图数据
  @Prop({
    default: {
      handLift: [],
      special: [],
      repair: [],
      free: []
    }
  })
  lineData: any;
  //时间范围
  @Prop({ default: () => [] })
  trendTimeRange: string[];

  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {
      show: true,
      formatter: function(params, ticket, callback) {
        let html = '';
        if (params) {
          for (let i = 0; i < params.length; i++) {
            if (i < 4) {
              html += `<div class="abnormal-overview-tooltip-item v${i + 1}">${params[i].seriesName}:<span>${
                params[i].data ? params[i].data : 0
              }</span></div>`;
            } else {
              html += `<div class="abnormal-overview-tooltip-item v${i + 1}">${params[i].seriesName}:<span>${
                params[i].data ? params[i].data : 0
              }%</span></div>`;
            }
          }
          return '<div class="abnormal-overview-tooltip">' + html + '</div>';
        }
        return '';
      },
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    };
  }

  get grid() {
    return {
      top: '4%',
      left: 0,
      right: 0,
      bottom: 0,
      containLabel: true
    };
  }

  get legend() {
    return {
      show: false,
      selectedMode: false,
      data: [
        { name: '手动抬杆数', icon: 'roundRect' },
        { name: '特殊放行数', icon: 'roundRect' },
        { name: '车辆修正数', icon: 'roundRect' },
        { name: '免费放行数', icon: 'roundRect' },
        { name: '手动抬杆率', icon: 'circle' },
        { name: '特殊放行率', icon: 'circle' },
        { name: '车辆修正率', icon: 'circle' },
        { name: '免费放行率', icon: 'circle' }
      ]
    };
  }

  get xAxis() {
    return [
      {
        type: 'category',
        // data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        data: this.trendTimeRange,
        axisPointer: {
          type: 'shadow'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      }
    ];
  }

  get yAxis() {
    return [
      {
        type: 'value',
        min: 0,
        // interval: 50,
        axisLabel: {
          formatter: '{value} '
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#ccc',
            type: 'dashed'
          }
        }
      },
      {
        type: 'value',
        min: 0,
        // interval: 5,
        axisLabel: {
          formatter: '{value}%'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: false
        }
      }
    ];
  }

  get series() {
    return [
      {
        name: '手动抬杆数',
        type: 'bar',
        stack: '异常操作',
        // data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
        data: this.barData.handLift,
        barMaxWidth: '40'
      },
      {
        name: '特殊放行数',
        type: 'bar',
        stack: '异常操作',
        // data: [1, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
        data: this.barData.special,
        barMaxWidth: '40'
      },
      {
        name: '车辆修正数',
        type: 'bar',
        stack: '异常操作',
        // data: [2, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
        data: this.barData.repair,
        barMaxWidth: '40'
      },
      {
        name: '免费放行数',
        type: 'bar',
        stack: '异常操作',
        // data: [2, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
        data: this.barData.free,
        barMaxWidth: '40'
      },
      {
        name: '手动抬杆率',
        type: 'line',
        yAxisIndex: 1,
        // data: [3, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
        data: this.lineData.handLift
      },
      {
        name: '特殊放行率',
        type: 'line',
        yAxisIndex: 1,
        // data: [4, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
        data: this.lineData.special
      },
      {
        name: '车辆修正率',
        type: 'line',
        yAxisIndex: 1,
        // data: [5, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
        data: this.lineData.repair
      },
      {
        name: '免费放行率',
        type: 'line',
        yAxisIndex: 1,
        // data: [5, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
        data: this.lineData.free
      }
    ];
  }

  get colors() {
    return ['#3aa1ff', '#4ecb73', '#f2637b', '#975fe5', '#3aa1ff', '#4ecb73', '#f2637b', '#975fe5'];
  }

  refreshChart() {
    const options: EchartOption = new EchartOption();
    options.setColor(this.colors);
    options.setLegend(this.legend);
    options.setGrid(this.grid);
    options.setXAxis(this.xAxis, true);
    options.setYAxis(this.yAxis, true);
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setTooltip(this.toolTip);
    this.options = options;
  }

  init() {}

  mounted() {
    // this.refreshChart()
  }
}
